// set flag to Item if item is last page (case delete last item -> back to page previous)
export const mappingDataPagination = (data, page, totalPage) => {
  if (!data) return [];
  if (Number(page) !== 1 && Number(page) === totalPage && data.length === 1) {
    data[0].isLastItemInPage = true;
  }
  return data;
};
